import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { TransferRequestsApi, type TransferCreateRequest, type TransferRequestResponse } from '@shared/api';

const createTransferEffect = createEffect((request: TransferCreateRequest) => TransferRequestsApi.create(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestResponse | null>(null)
  .on(createTransferEffect.done, (_, data) => data.result.data! || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(createTransferEffect.pending, (_, data) => data)
  .on(createTransferEffect.fail, () => false)
  .on(createTransferEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(createTransferEffect, () => null)
  .on(
    createTransferEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while creating Transfer. Please try again.').message,
  )
  .on(createTransferEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $transferRequestsCreateStore = {
  events: {
    createTransfer: createTransferEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
